import { render, staticRenderFns } from "./Woorden.vue?vue&type=template&id=47e7f152&scoped=true"
import script from "./Woorden.vue?vue&type=script&lang=js"
export * from "./Woorden.vue?vue&type=script&lang=js"
import style0 from "./Woorden.vue?vue&type=style&index=0&id=47e7f152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7f152",
  null
  
)

export default component.exports